import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialStackModule } from '@zerops/zerops/core/material-stack';
import { DialogErrorContainer } from './dialog-error.container';
import { ZuiSeparatorComponent } from '@zerops/zui/separator';
import { SudoReauthModule } from '@zerops/zerops/feature/sudo-reauth';

@NgModule({
  declarations: [ DialogErrorContainer ],
  imports: [
    CommonModule,
    MaterialStackModule,
    ZuiSeparatorComponent,
    SudoReauthModule
  ],
  exports: [ DialogErrorContainer ]
})
export class DialogErrorModule {

}
